import { useEffect } from "react";
import { brand } from "../brand";

export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = `${title} | ${brand.displayName}`;
  }, [title]);
}
